import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpService } from 'modules/shared/legacy-bookexpress/services/http.service';
import { environment } from '../../../../environments/environment';
import { ProductConfigResponse } from 'model/shared/backend-api-response/product-config-response';
import { saveAs } from 'file-saver';
// import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';

@Injectable({
  providedIn: 'root',
})
export class CommonDataService {
  public tenantId: string;
  public propertyId: string;
  public appName: string;
  public isLanguageLoaderEnable: boolean = false;
  public cloudBackendDomain: string = environment.backendApiUrl;
  public token: string;
  public configUrl: string = 'wbe-property-service/property';
  public languages = new BehaviorSubject<any>({});
  public isLoginPage: boolean = true;
  public groupDefaultLanguage: string = 'EN';

  constructor(
    public httpService: HttpService // , public legacyBookInit: LegacyBookInitService
  ) {
    if (environment.proxy) {
      this.cloudBackendDomain = environment.backendApiUrl;
    } else {
      let hostName = document.location.hostname;
      this.cloudBackendDomain = window.location.protocol + '//' + hostName;
    }
  }
  getLanguages(lang: String) {
    this.isLanguageLoaderEnable = true;
    if (environment.proxy) {
      this.httpService.proxy = environment.proxy;
      this.cloudBackendDomain = environment.backendApiUrl;
    } else {
      let hostName = document.location.hostname;
      this.cloudBackendDomain = window.location.protocol + '//' + hostName;
    }

    let url = `${this.cloudBackendDomain}/wbe-property-service/property/tenants/${this.tenantId}/propertyId/${this.propertyId}/uiMessages?appName=${this.appName}&langCode=${lang}`;
    this.httpService.get(url).subscribe({
      next: (languages: ProductConfigResponse) => {
        let languageSessionKey = `${this.tenantId}-${this.propertyId}-selectedLanguage`;
        if (languages.Success && Object.keys(languages?.propertyInitInfoMap).length) {
          sessionStorage.setItem(languageSessionKey, lang.toString());
          this.checkForLangCodeQueryParam(languageSessionKey, lang);
          this.languages.next(languages);
        } else {
          languages.ErrorMessage = languages?.ErrorMessage ? languages.ErrorMessage : 'Selected language is not configured';
          languages.Success = false;
          this.checkForLangCodeQueryParam(languageSessionKey, this.groupDefaultLanguage);
          this.languages.next(languages);
        }

        this.languages.next(languages);
        this.isLanguageLoaderEnable = false;
      },
      error: (err) => {
        this.isLanguageLoaderEnable = false;
      },
    });
  }

  checkForLangCodeQueryParam(languageSessionKey, onecartLanguage) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const queryParamLangCode = urlParams.get('langCode');
    if (queryParamLangCode) {
      const url = new URL(window.location.href);
      let searchParams = new URLSearchParams(url.search);
      searchParams.set('langCode', onecartLanguage);
      const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);
      sessionStorage.setItem(languageSessionKey, onecartLanguage);
    }
  }

  groupBookingPdfRequest(postBody, tenantId, propertyId, currency) {
    let langCode = sessionStorage.getItem(`${tenantId}-${propertyId}-selectedLanguage`) || 'EN';
    const url = `${this.cloudBackendDomain}/wbe-pdf-service/tenants/${tenantId}/groupBookingPdf?langCode=${langCode}&currencyCode=${currency}`;
    let httpOption: any = {
      responseType: 'blob',
    };
    return this.httpService.post(url, postBody, httpOption);
  }

  printPdf(blob) {
    const blobUrl = URL.createObjectURL(blob);
    const printWindow = window.open(blobUrl, 'print');
    if (printWindow) printWindow.print();
  }

  savePdf(blob, filename = 'document') {
    saveAs(blob, filename);
  }
}
